module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Edit Rule",
      "before-close": _vm.handleClose,
      "show-close": false,
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('rule', {
    attrs: {
      "rule": _vm.rule,
      "campaign": _vm.rule.campaign
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.rule.events) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addEmptyAction
    }
  }, [_vm._v("Add Action")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.saving,
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSave(_vm.rule)
      }
    }
  }, [_vm._v("Save Rule")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8a12200","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/rules/RuleEdit.vue
// module id = 3428
// module chunks = 3